var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8839 9.28811L12.0039 13.1681L8.1239 9.28811C8.03131 9.19553 7.9214 9.12209 7.80044 9.07199C7.67947 9.02188 7.54983 8.99609 7.4189 8.99609C7.28797 8.99609 7.15832 9.02188 7.03735 9.07199C6.91639 9.12209 6.80648 9.19553 6.7139 9.28811C6.62131 9.3807 6.54787 9.49061 6.49777 9.61157C6.44766 9.73254 6.42187 9.86218 6.42188 9.99311C6.42188 10.124 6.44766 10.2537 6.49777 10.3747C6.54787 10.4956 6.62131 10.6055 6.7139 10.6981L11.3039 15.2881C11.6939 15.6781 12.3239 15.6781 12.7139 15.2881L17.3039 10.6981C17.3966 10.6056 17.4701 10.4957 17.5203 10.3747C17.5705 10.2538 17.5963 10.1241 17.5963 9.99311C17.5963 9.86215 17.5705 9.73246 17.5203 9.61149C17.4701 9.49052 17.3966 9.38063 17.3039 9.28811C16.9139 8.90811 16.2739 8.89811 15.8839 9.28811Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.be77623dff86decf2782344e2bf6e8fd.svg";
export { ForwardRef as ReactComponent };